import React from 'react'

import { Div } from '@driftt/tide-core'

import InfoIcon from '../InfoIcon'

import './style.css'

const formatTooltip = (tooltip) => {
  if (typeof tooltip === 'string') {
    const content: any[] = tooltip
      .split(/\n|\\n/)
      .map((item, index) => <span key={`span-${index}`}>{item}</span>)

    for (let i = content.length - 1; i > 0; i--) {
      content.splice(i, 0, <br key={`br-${i}`} />)
    }
    return <Div>{content}</Div>
  }
  return tooltip
}

const Title = ({ title, tooltip, tooltipFlow }) => (
  <Div className="title-container">
    <Div className="title-title">{title}</Div>
    {tooltip && (
      <InfoIcon
        tooltipFlow={tooltipFlow}
        tooltipText={formatTooltip(tooltip)}
      />
    )}
  </Div>
)

export default Title
